var _path, _path2, _path3, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTxtFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6 51c0 1.657 1.343 3 3 3h4v-7h-5s-2 0-2 4z",
    fill: "#4b84dd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m54 12v43c0 2.209-1.791 4-4 4h-34c-2.209 0-4-1.791-4-4v-50c0-2.209 1.791-4 4-4h27s11 11 11 11z",
    fill: "#e8ecef"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m54 12h-10c-.55 0-1-.45-1-1v-10z",
    fill: "#c7d0dd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m9 48h36c1.657 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3h-36c-1.657 0-3 1.343-3 3v20c0-1.657 1.343-3 3-3z",
    fill: "#69adfe"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20 32h-6c-.553 0-1 .447-1 1s.447 1 1 1h2v9c0 .553.447 1 1 1s1-.447 1-1v-9h2c.553 0 1-.447 1-1s-.447-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.515 32.143c-.474-.284-1.088-.13-1.372.343l-2.143 3.571-2.143-3.571c-.284-.473-.897-.627-1.372-.343-.474.284-.627.898-.343 1.372l2.691 4.485-2.691 4.485c-.284.474-.131 1.088.343 1.372.161.097.339.143.514.143.34 0 .671-.173.858-.485l2.143-3.571 2.143 3.571c.188.312.519.485.858.485.175 0 .353-.046.514-.143.474-.284.627-.898.343-1.372l-2.691-4.485 2.691-4.485c.284-.474.131-1.088-.343-1.372z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 32h-6c-.553 0-1 .447-1 1s.447 1 1 1h2v9c0 .553.447 1 1 1s1-.447 1-1v-9h2c.553 0 1-.447 1-1s-.447-1-1-1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxtFile);
export default __webpack_public_path__ + "static/media/txt-file.bd4cf91261963dea56659d6d7e14f444.svg";
export { ForwardRef as ReactComponent };